import { render, staticRenderFns } from "./NewShopNoWebhookBot.vue?vue&type=template&id=16f4bb1e&"
import script from "./NewShopNoWebhookBot.vue?vue&type=script&lang=js&"
export * from "./NewShopNoWebhookBot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports